import React from 'react';
import { Helmet } from 'react-helmet-async';
import { companyInfo } from '../mock';

const SchemaMarkup = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://nypestexterminating.com",
    "name": companyInfo.name,
    "image": "https://nypestexterminating.com/logo.png",
    "description": "Professional eco-friendly pest control services in New York City. Serving all 5 boroughs with same-day service. Licensed, insured, and Green Shield Certified.",
    "url": "https://nypestexterminating.com",
    "telephone": companyInfo.phoneRaw,
    "email": companyInfo.email,
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "New York",
      "addressRegion": "NY",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.7128",
      "longitude": "-74.0060"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Brooklyn"
      },
      {
        "@type": "City",
        "name": "Manhattan"
      },
      {
        "@type": "City",
        "name": "Queens"
      },
      {
        "@type": "City",
        "name": "The Bronx"
      },
      {
        "@type": "City",
        "name": "Staten Island"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Nassau County"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Suffolk County"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Westchester County"
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/nypestexterminating",
      "https://www.instagram.com/nypestexterminating",
      "https://www.linkedin.com/company/nypestexterminating"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Pest Control Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Rodent Control"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Bed Bug Extermination"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Termite Treatment"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Commercial Pest Control"
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
